(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("EcommerceGallery", [], factory);
	else if(typeof exports === 'object')
		exports["EcommerceGallery"] = factory();
	else
		root["EcommerceGallery"] = factory();
})(this, function() {
return 